// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wtv-stars[data-v-0b5d1b5c]{display:flex;margin-right:8px;margin-left:8px}.wtv-star[data-v-0b5d1b5c],.wtv-star-unchecked[data-v-0b5d1b5c]{margin-right:2px;cursor:pointer}.wtv-star-unchecked[data-v-0b5d1b5c]:before,.wtv-star[data-v-0b5d1b5c]:before{content:\"\\f005\";font-size:14px}.wtv-star[data-v-0b5d1b5c]:before{color:var(--color-third)}.wtv-star-unchecked[data-v-0b5d1b5c]:before{color:var(--color-alt-5)}", ""]);
// Exports
module.exports = exports;
